import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { notifyError, notifyTopRight } from "../Common/Toaster";
import { updateDiscoverPriority } from "../../../services/UserServices/UserService";
import {
  DISCOVER_PRIORITY_OPTIONS,
  getDiscoverPriorityLabel,
} from "../Common/DiscoverPriority";

const DiscoverPriorityModal = ({
  show,
  id,
  currentValue,
  table,
  setLoader,
  onHide,
}) => {
  const initial =
    currentValue === 1 || currentValue === 2 || currentValue === 3
      ? String(currentValue)
      : "";
  const [priority, setPriority] = useState(initial);

  useEffect(() => {
    if (show) {
      setPriority(
        currentValue === 1 || currentValue === 2 || currentValue === 3
          ? String(currentValue)
          : ""
      );
    }
  }, [show, currentValue]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const discoverPriority = priority === "" ? null : Number(priority);
    if (
      discoverPriority !== null &&
      discoverPriority !== 1 &&
      discoverPriority !== 2 &&
      discoverPriority !== 3
    ) {
      notifyError("Please select a valid priority");
      return;
    }

    if (typeof setLoader === "function") setLoader(true);
    try {
      await updateDiscoverPriority({
        userId: id,
        discoverPriority,
      });
      notifyTopRight(
        discoverPriority === null
          ? "Discover priority removed"
          : `Discover priority set to ${getDiscoverPriorityLabel(discoverPriority)}`
      );
      if (typeof table === "function") table();
      onHide();
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
    } finally {
      if (typeof setLoader === "function") setLoader(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <form onSubmit={handleSubmit}>
        <div className="modal-header">
          <h4 className="modal-title fs-20">Set Discover Priority</h4>
        </div>
        <div className="modal-body">
          <div className="form-group mb-3">
            <label className="text-black font-w500">Priority</label>
            <select
              className="form-control"
              value={priority}
              onChange={(e) => setPriority(e.target.value)}
            >
              <option value="">None (not tagged)</option>
              {DISCOVER_PRIORITY_OPTIONS.map((opt) => (
                <option key={opt.value} value={String(opt.value)}>
                  {opt.label}
                </option>
              ))}
            </select>
            <small className="text-muted d-block mt-2">
              Current: {getDiscoverPriorityLabel(currentValue)}
            </small>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" onClick={onHide} className="btn btn-danger">
            <i className="flaticon-delete-1"></i> Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default DiscoverPriorityModal;
